(function () {
  'use strict';

  /* @ngdoc object
   * @name cancellations.postponeCanceledMatches
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.canceledMatches.postponeCanceledMatches', [
      'ui.router'
    ]);
}());
